import { render } from "./icon-gr-farm.svg?vue&type=template&id=6d4de798?inline"
const script = {}
script.render = render

export default script